export default __webpack_public_path__ + "locales/bg/EmptyTrashDialog.json?hash=a789eafc705f7a22e25a55abe492d1fb";